import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";

const VendorsLotPaymentsTitleColumns = () => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} rowWidth={1} alignX="start">
            <I18n component="span" id="thirdPayment.pay.id" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} rowWidth={1} alignX="center">
            <I18n component="span" id="payments.newPayment.debitAccountId.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} rowWidth={1} alignX="center">
            <I18n component="span" id="payThirdParties.process.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} rowWidth={1} alignX="center">
            <I18n component="span" id="thirdPayment.orders" />
        </GridTable.Data>
        <GridTable.Data columnStart={5} rowStart={1} rowWidth={1} alignX="center">
            <I18n component="span" id="transfer.amountField.label" />
        </GridTable.Data>
        <GridTable.Data columnStart={6} rowStart={1} rowWidth={1} alignX="center">
            <I18n component="span" id="tableHeader.state" />
        </GridTable.Data>
    </>
);
export default VendorsLotPaymentsTitleColumns;
